/* eslint-disable no-console */
import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject, isDevMode } from "@angular/core";
import { Router } from "@angular/router";
import { NEVER, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { Constants } from "../../shared/constants/constants";
import { LogoutService } from "../../shared/services";

/**
 * Handles all errors from the server
 *
 * @param {HttpRequest} req
 * @param {HttpHandlerFn} next
 * @returns
 */
export function errorsInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const router = inject(Router);
  const logoutService = inject(LogoutService);

  let sessionErrorHandled = false;

  const isSessionError = (error: HttpErrorResponse) => {
    if (error.error) {
      return +error.error.responseCode === Constants.CONSTANT_ERROR_CODE.SESSION_EXPIRED;
    }
    return false;
  };

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (isSessionError(error)) {
        if (!sessionErrorHandled) {
          sessionErrorHandled = true;
          localStorage.setItem(Constants.localStorageKeys.lastUrlVisited, router.url);
          localStorage.setItem(Constants.localStorageKeys.sessionExpired, "true");
          logoutService.logout(true);
        }

        // Session expiry is expected: the user is being logged out, so swallow the
        // error instead of propagating it to the global error handler / Sentry.
        // NEVER rather than EMPTY: completing without a value makes every consumer
        // that requires an emission fail instead (`first()`, `firstValueFrom`, a
        // `forkJoin` that then completes empty), which only trades one reported
        // error for another. The logout redirects the document, so nothing is left
        // waiting on this stream.
        return NEVER;
      }

      if (isDevMode()) {
        console.groupCollapsed(`Response Error from ${req.url} - [method: ${req.method}]`);
        console.log(error);
        console.groupEnd();
      }

      return throwError(() => error);
    })
  );
}
